import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { LocationAutocomplete } from '@/components/LocationAutocomplete/LocationAutocomplete'
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'

import type { GooglePlace } from '../utils/applyGooglePlaceToForm'

import { CompanyContextField } from './CompanyContextField'

interface CompanyInfoFieldsProps {
  onPlaceSelected: (place: GooglePlace) => void
}

export const CompanyInfoFields = ({
  onPlaceSelected,
}: CompanyInfoFieldsProps) => {
  const { t } = useTranslation()
  const { control } = useFormContext()

  return (
    <div className="flex flex-col gap-4 lg:flex-1">
      <p className="text-base font-medium text-neutralColor lg:text-xl">
        {t('dashboard.runReport.companyInfoFields.title')}
      </p>
      <div className="flex flex-col gap-3 md:flex-row md:gap-6">
        <FormField
          control={control}
          name="companyName"
          render={({ field }) => (
            <FormItem className="flex-1">
              <FormLabel className="sr-only">
                {t('dashboard.runReport.companyInfoFields.companyName')}
              </FormLabel>
              <FormControl>
                <Input
                  {...field}
                  placeholder={t(
                    'dashboard.runReport.companyInfoFields.companyNamePlaceholder',
                  )}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name="companyWebsite"
          render={({ field }) => (
            <FormItem className="flex-1">
              <FormLabel className="sr-only">
                {t('dashboard.runReport.companyInfoFields.companyWebsite')}
              </FormLabel>
              <FormControl>
                <Input
                  {...field}
                  placeholder={t(
                    'dashboard.runReport.companyInfoFields.companyWebsitePlaceholder',
                  )}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <FormField
        control={control}
        name="industry"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="sr-only">
              {t('dashboard.runReport.companyInfoFields.industry')}
            </FormLabel>
            <FormControl>
              <Input
                {...field}
                placeholder={t(
                  'dashboard.runReport.companyInfoFields.industryPlaceholder',
                )}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="countryLongName"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="sr-only">
              {t('dashboard.runReport.companyInfoFields.location')}
            </FormLabel>
            <FormControl>
              <LocationAutocomplete
                onPlaceSelected={onPlaceSelected}
                defaultValue={field.value}
                placeholder={t(
                  'dashboard.runReport.companyInfoFields.locationPlaceholder',
                )}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <CompanyContextField />
    </div>
  )
}
